function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.597015 15.2213H9.66846C9.99818 15.2213 10.2655 14.954 10.2655 14.6243V3.0394C10.2655 2.70968 9.99818 2.44238 9.66846 2.44238H0.597015C0.267293 2.44238 0 2.70968 0 3.0394V14.6243C0 14.954 0.267293 15.2213 0.597015 15.2213ZM9.07144 14.0273H1.19403V3.63641H9.07144V14.0273Z",
  fill: "#0A4AB7"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6391 12H9.50133C9.18014 12 8.91976 11.749 8.91976 11.4394C8.91976 11.1298 9.18014 10.8787 9.50133 10.8787H12.0576V1.12125H4.38385V3.58501C4.38385 3.89464 4.12347 4.14564 3.80228 4.14564C3.48108 4.14564 3.2207 3.89464 3.2207 3.58501V0.560625C3.2207 0.251001 3.48108 0 3.80228 0H12.6391C12.9603 0 13.2207 0.251001 13.2207 0.560625V11.4394C13.2207 11.749 12.9603 12 12.6391 12Z",
  fill: "#0A4AB7"
});

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.8b9b12a76d6387ea33cf29b3e6bfca2f.svg";
export { ForwardRef as ReactComponent };